var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v("Win版Anymo下载会提示提示软件信任问题")]),_c('p',[_vm._v("解决方法如下：")]),_c('p',[_vm._v("1.页面弹窗的右上角的三个点，选择保留即可：")]),_c('p',[_c('img',{attrs:{"src":"/static/image/win.png","width":"350px"}})]),_c('div',{staticClass:"h-200"})])
}]

export { render, staticRenderFns }